import { HttpBackend, HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { Config } from './config';
import { ConfigRepository } from './config.repository';

const CONFIG_URL = '/assets/config/config.json';

@Injectable()
export class ConfigService implements ConfigRepository {
  private readonly http = new HttpClient(inject(HttpBackend));
  private readonly config = this.fetchConfig();

  getConfig(): Promise<Config> {
    return this.config;
  }

  private fetchConfig(): Promise<Config> {
    return firstValueFrom(this.http.get<Config>(CONFIG_URL));
  }
}
